import React, { forwardRef } from "react";
import MalfunctionTurbineSvg from "./MalfunctionTurbineSvg";
import malfunctionsSVGUrlFrancis from "assets/svgs/malfunctions_francis-turbine.svg";
import malfunctionsSVGUrlFrancisMiv from "assets/svgs/malfunctions_francis-turbine+miv.svg";
import malfunctionsSVGUrlFrancisHorizontal from "assets/svgs/malfunctions_francis-horizontal.svg";
import malfunctionsSVGUrlFrancisUpperCombBearing from "assets/svgs/malfunctions_francis-upper-comb-bearing.svg";
import malfunctionsSVGUrlKaplanVertical from "assets/svgs/malfunctions_kaplan-vertical.svg";
import malfunctionsSVGUrlKaplanVerticalTest from "assets/svgs/malfunctions_kaplan-vertical-test.svg";
import malfunctionsSVGUrlKaplanHorizontal from "assets/svgs/malfunctions_kaplan-horizontal.svg";
import malfunctionsSVGUrlPeltonMiv from "assets/svgs/malfunctions_pelton+miv.svg";
import malfunctionsSVGUrlPeltonHorizontal from "assets/svgs/malfunctions_pelton-horizontal.svg";
import malfunctionsSVGUrlSynchronousCondenser from "assets/svgs/malfunctions_synchronous-condenser.svg";

import PropTypes from "prop-types";
import { turbineTypes } from "utils/constants";

const SvgGraphic = forwardRef((props, ref) => {
  const { svgPath } = props;
  switch (svgPath) {
    case turbineTypes.FRANCIS: {
      return (
        <MalfunctionTurbineSvg
          svgSrc={malfunctionsSVGUrlFrancis}
          {...props}
          ref={ref}
        />
      );
    }
    case turbineTypes.FRANCIS_MIV: {
      return (
        <MalfunctionTurbineSvg
          svgSrc={malfunctionsSVGUrlFrancisMiv}
          {...props}
          ref={ref}
        />
      );
    }
    case turbineTypes.FRANCIS_HORIZONTAL: {
      return (
        <MalfunctionTurbineSvg
          svgSrc={malfunctionsSVGUrlFrancisHorizontal}
          {...props}
          ref={ref}
        />
      );
    }
    case turbineTypes.FRANCIS_UPPER_COMB_BEARING: {
      return (
        <MalfunctionTurbineSvg
          svgSrc={malfunctionsSVGUrlFrancisUpperCombBearing}
          {...props}
          ref={ref}
        />
      );
    }
    case turbineTypes.KAPLAN_VERTICAL: {
      return (
        <MalfunctionTurbineSvg
          svgSrc={malfunctionsSVGUrlKaplanVertical}
          {...props}
          ref={ref}
        />
      );
    }
    case turbineTypes.KAPLAN_VERTICAL_TEST: {
      return (
        <MalfunctionTurbineSvg
          svgSrc={malfunctionsSVGUrlKaplanVerticalTest}
          {...props}
          ref={ref}
        />
      );
    }
    case turbineTypes.KAPLAN_HORIZONTAL: {
      return (
        <MalfunctionTurbineSvg
          svgSrc={malfunctionsSVGUrlKaplanHorizontal}
          {...props}
          ref={ref}
        />
      );
    }
    case turbineTypes.PELTON_MIV: {
      return (
        <MalfunctionTurbineSvg
          svgSrc={malfunctionsSVGUrlPeltonMiv}
          {...props}
          ref={ref}
        />
      );
    }
    case turbineTypes.PELTON_HORIZONTAL: {
      return (
        <MalfunctionTurbineSvg
          svgSrc={malfunctionsSVGUrlPeltonHorizontal}
          {...props}
          ref={ref}
        />
      );
    }
    case turbineTypes.SYNCHRONOUS_CONDENSER: {
      return (
        <MalfunctionTurbineSvg
          svgSrc={malfunctionsSVGUrlSynchronousCondenser}
          {...props}
          ref={ref}
        />
      );
    }
    default: {
      return (
        <MalfunctionTurbineSvg
          svgSrc={malfunctionsSVGUrlFrancis}
          {...props}
          ref={ref}
        />
      );
    }
  }
});

SvgGraphic.propTypes = {
  svgPath: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onDrag: PropTypes.func,
  onStop: PropTypes.func,
  malfunctions: PropTypes.arrayOf(PropTypes.object),
  handleMouseOver: PropTypes.func,
  disabled: PropTypes.bool,
};

SvgGraphic.defaultProps = {
  svgPath: "francis",
  width: 1150,
  height: 766,
  onDrag: () => console.log("onDrag"),
  onStop: () => console.log("onStop"),
  malfunctions: [],
  handleMouseOver: () => console.log("handleMouseOver"),
  disabled: true,
};

export default SvgGraphic;
